import { ViewModel,View, ObservableArray } from "binder"
import moment from "moment";
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import { stringIsNullOrEmpty } from "src/common/utilities";
import { ServerConnection } from "src/server/serverConnection";
import { ServerSideDataLoader, PaginationInfo } from "uicomponents";
import { BankAccountSelectorViewModel } from "../bankAccountManipulation/bankAccountManipulation-viewModel";
import  { IbanGatewayManipulationView } from "./ibanGatewayManipulation-view"

export class IbanGatewayManipulationViewModel extends WindowViewModel{
    public getTitle(): string {
        return 'مدیریت شبا ';
    }
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.ibanGateway = ObservableArray.create<ibanGateway>();
        this.loader = new ServerSideDataLoader(filteringInformation=>this.refreshPaged(filteringInformation),15);
        this.refresh();
    }
    GetDefaultView(): View <ViewModel> {
        return new IbanGatewayManipulationView();
    }
    public getTypeId(): string {
        return "VM-E359F1E2-5BFB-4933-911E-9374B18A5BF8"
    }
    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader;} private _loader: ServerSideDataLoader;
    public set ibanGateway(v: ObservableArray<ibanGateway>) { this._ibanGateway = v; } public get ibanGateway(): ObservableArray<ibanGateway> { return this._ibanGateway;} private _ibanGateway: ObservableArray<ibanGateway>;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    
    refresh(){
        this.loader.refresh();
    }
    async refreshPaged(filteringInformation:any): Promise<PaginationInfo>{
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/FinancialServices/GetAllIbanGateway',{
                FilteringInformation:filteringInformation
            });
            this.ibanGateway.update(...result.IbanGateway.map((q,i)=>{
                let r = new ibanGateway(this);
                r.id = q.Id;
                r.rowNumber = i+1;
                r.bankId = q.BankId;
                r.bankName = q.BankName;
                r.districtId = q.DistrictId;
                r.districtName = q.DistrictName;
                r.accountId = q.AccountId;
                r.accountName = q.AccountName;
                r.serialNumber = q.SerialNumber;
                r.needConfirmation = q.NeedConfirmation;  
                r.createDate = moment.utc(q.CreateDate);
                r.removeDate = q.RemoveDate==null? null : moment.utc(q.RemoveDate);          
                r.canInvalidate = q.RemoveDate==null;          
                return r;
            }));
            return new PaginationInfo(result.PaginationInfo.CurrentPage,result.PaginationInfo.PageCount);
        } catch (ex) {
            console.log(ex);
            return new PaginationInfo(0,0);
        } finally {
            this.isLoading = false;
        }
    }
    async requestIbanGatewayCreation(){
        let editor = new ibanGatewayEditor(this,new InsertServerUpdater());
        let resultCode = await this.showPopup(editor);
        if(resultCode=='done'){
            this.loader.refresh();
        }
    }
        
    async ibanGatewayUpdater(ibanGateway:ibanGateway){
        let editor = new ibanGatewayEditor(this,new UpdateServerUpdater());
        ibanGateway.cloneTo(editor);
        let resultCode = await this.showPopup(editor);
        if(resultCode=='done'){
            this.loader.refresh();
        }
    }
    
    async accept(id:any){
        try {
            this.isLoading = true;
            await ServerConnection.callServer('/Complex/FinancialServices/InvalidateIbanGateway',{
                IbanGatewayId:id
            });
            await this.messageBoxConfirmSuccess('شبا غیر فعال شد','عملیات موفق');
        } catch (ex) {
            console.log(ex);
            await this.messageBoxConfirmWarning('خطا در انجام عملیات','خطا');
        } finally {
            this.isLoading = false;
            this.loader.refresh();
        }
    }
}

export class ibanGateway extends ViewModel{
    
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:IbanGatewayManipulationViewModel) {
        super(parent);
        this._typedParent = parent;
        
    }
    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set rowNumber(v: number) { this._rowNumber = v; } public get rowNumber(): number { return this._rowNumber;} private _rowNumber: number;
    public set serialNumber(v: string) { this._serialNumber = v; } public get serialNumber(): string { return this._serialNumber;} private _serialNumber: string;
    public set needConfirmation(v: boolean) { this._needConfirmation = v; } public get needConfirmation(): boolean { return this._needConfirmation;} private _needConfirmation: boolean;
    public set createDate(v: moment.Moment) { this._createDate = v; } public get createDate(): moment.Moment { return this._createDate;} private _createDate: moment.Moment;
    public set removeDate(v: moment.Moment) { this._removeDate = v; } public get removeDate(): moment.Moment { return this._removeDate;} private _removeDate: moment.Moment;
    public set canInvalidate(v: boolean) { this._canInvalidate = v; } public get canInvalidate(): boolean { return this._canInvalidate;} private _canInvalidate: boolean;
    
    public set accountId(v: string) { this._accountId = v; } public get accountId(): string { return this._accountId;} private _accountId: string;
    public set accountName(v: string) { this._accountName = v; } public get accountName(): string { return this._accountName;} private _accountName: string;
    public set districtId(v: string) { this._districtId = v; } public get districtId(): string { return this._districtId;} private _districtId: string;
    public set districtName(v: string) { this._districtName = v; } public get districtName(): string { return this._districtName;} private _districtName: string;
    public set bankName(v: string) { this._bankName = v; } public get bankName(): string { return this._bankName;} private _bankName: string;
    public set bankId(v: string) { this._bankId = v; } public get bankId(): string { return this._bankId;} private _bankId: string;
    
    private _typedParent:IbanGatewayManipulationViewModel;

    cloneTo(ibanGateway:ibanGateway){
        ibanGateway.id = this.id;
        ibanGateway.serialNumber = this.serialNumber;
        ibanGateway.needConfirmation = this.needConfirmation;
        ibanGateway.setAccount(this.getAccountId(), this.accountName);
    }

    setAccount(id: string, name: string) {
        this.accountId = id;
        this.accountName = name;
    }
    getAccountId() {
        return this.accountId;
    }  

    setDistrict(id: string, name: string) {
        this.districtId = id;
        this.districtName = name;
    }
    getDistrictId() {
        return this.districtId;
    }

    setBank(id: string, name: string) {
        this.bankId = id;
        this.bankName = name;
    }
    getBankId() {
        return this.bankId;
    }
    
    async inactiveIbanGateway():Promise<void>{
        if(this.canInvalidate) {
            let result:string; 
            result = await this.messageBoxWarningYesNo('آیا مطمئنید؟','غیرفعال کردن کارت');
            if(result=='yes'){
                this._typedParent.accept(this.id);
            }
        }
    }
    
    async edit(){
        this._typedParent.ibanGatewayUpdater(this);
    }  
}

interface IServerUpdater{
    execute(ibanGateway:ibanGateway):Promise<void>;
    getSuccessMessage():string;
}

class InsertServerUpdater implements IServerUpdater{
    getSuccessMessage(): string {
        return ' شبا با موفقیت ثبت شد.';
    }
    async execute(ibanGateway: ibanGateway): Promise<void> {
        let result = await ServerConnection.callServer('/Complex/FinancialServices/CreateIbanGateway',{
            AccountId:ibanGateway.getAccountId(),
            SerialNumber:ibanGateway.serialNumber,
            NeedConfirmation:ibanGateway.needConfirmation,
        });
        if(result.IsSuccessful==false){
            if (result.Faults[0].Parameters.FaultId === "096473E7-67AE-4206-9B61-79B70943684A")
                throw "شماره شبا تکراری است.";
            throw "خطا در انجام عملیات";
        }
    }
}

class UpdateServerUpdater implements IServerUpdater{
    getSuccessMessage(): string {
        return 'شبا با موفقیت به روز رسانی شد.';
    }
    async execute(ibanGateway: ibanGateway): Promise<void> {
        let result = await ServerConnection.callServer('/Complex/FinancialServices/UpdateIbanGateway',{
            Id:ibanGateway.id,
            AccountId:ibanGateway.getAccountId(),
            SerialNumber:ibanGateway.serialNumber,
            NeedConfirmation:ibanGateway.needConfirmation,
        });
        if(result.IsSuccessful==false){
            if (result.Faults[0].Parameters.FaultId === "096473E7-67AE-4206-9B61-79B70943684A")
                throw "شماره شبا تکراری است.";
            throw "خطا در انجام عملیات";
        }
    }
}

export class ibanGatewayEditor extends ibanGateway implements IPopup{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}

    constructor(parent:IbanGatewayManipulationViewModel,serverUpdater:IServerUpdater) {
        super(parent);
        this._serverUpdater = serverUpdater;
        this.accountSelector = new BankAccountSelectorViewModel(this);
    }
    closePopup(resultCode: string = null) {
    }
    
    private _serverUpdater:IServerUpdater;
    public set accountSelector(v: BankAccountSelectorViewModel) { this._accountSelector = v; } public get accountSelector(): BankAccountSelectorViewModel { return this._accountSelector;} private _accountSelector: BankAccountSelectorViewModel;
    
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    
    verify():string[]{
        let result :string[] =[];
        if(stringIsNullOrEmpty(this.serialNumber)){
            result.push(' شماره شبا مشخص نشده است.')
        }
        if(stringIsNullOrEmpty(this.getAccountId())){
            result.push(' حساب مشخص نشده است.')
        }
        return result;
    }

    setAccount(id: string, name: string) {
        this.accountSelector.selectById(id);
    }

    getAccountId() {
        return this.accountSelector.selectedItem?.id;
    }
    
    async save(){
        try {
            let verificationResult = this.verify();
            if(verificationResult.length>0){
                let errorMessage = verificationResult.join('\n');
                await this.messageBoxConfirmWarning(errorMessage,'عدم امکان ثبت شبا');
                return;
            }
            this.isLoading = true;
            await this._serverUpdater.execute(this);
            await this.messageBoxConfirmSuccess(this._serverUpdater.getSuccessMessage(),'عملیات موفق');
            this.closePopup("done")
        } catch (ex) {
            console.log(ex);
            await this.messageBoxConfirmWarning(ex,'خطا');
        } finally {
            this.isLoading = false;
        }
    }

    back(){
        this.closePopup();
    }

}

